@if (icon(); as icon) {
  <mat-icon class="selection-info-icon material-icons-outlined" [mpIcon]="icon" />
}

<div class="truncate">
  {{ label() }}
</div>
